import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet } from '@/src/tools/tools';
import React from 'react';
import css from './css.module.less';
import { Item as ItemWrapper } from 'src/components/Layouts';
import { postGiftContact } from 'src/request/order';
import { MobileNumberAreaInfo } from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
import {
  Input,
  ModalFooter,
  // NumberInput,
  // OriSelect,
} from 'src/components/Antd';
import { getAreaCodeUuid } from '@/src/tools/tools';
// import { generalFilterOptions } from 'src/tools/helper';

// const Option = OriSelect.Option;

const Editor = (props) => {
  const { data, onSubmit, onCancel, uuid } = props;
  const { email: e, mobile: m, areaCodeInfo: aU } = data || {};
  const { uuid: a } = aU || {};
  const [areaCodeInfoUuid, setAreaCodeInfoUuid] = React.useState(a);
  const [email, setEmail] = React.useState(e);
  const [mobile, setMobile] = React.useState(m);
  const [mobileErr, setMobileErr] = React.useState(false);
  const [validateErr, setValidateErr] = React.useState(false);
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const handleOnSubmit = () => {
    if (!email && !mobile && !email) {
      setValidateErr(true);
      return;
    }
    if (!mobile || !areaCodeInfoUuid) {
      setMobileErr(true);
      return;
    }
    postGiftContact({
      uuid,
      contact: {
        areaCodeInfo: { uuid: areaCodeInfoUuid }, //areaCode,
        email,
        mobile,
      },
    }).then(() => {
      onSubmit({
        areaCodeInfo: { uuid: areaCodeInfoUuid },
        email,
        mobile,
      });
    });
  };

  return (
    <React.Fragment>
      <div className={css.modalContainer}>
        <ItemWrapper
          title={getI18n(
            'giftCard.giftCardDetail.issueinfo_editor_return_email_title',
          )}>
          <Input
            value={email}
            onChange={(e) => {
              setValidateErr(false);
              setEmail(e);
            }}
            size='large'
          />
        </ItemWrapper>
        <ItemWrapper title='Mobile'>
          <MobileNumberAreaInfo
            value={{
              areaCodeInfo: { uuid: areaCodeInfoUuid },
              mobileNumber: mobile,
            }}
            onChange={(value) => {
              const { areaCodeInfo: a, mobileNumber: m } = value || {};
              setValidateErr(false);
              if (getAreaCodeUuid(a) !== areaCodeInfoUuid)
                setAreaCodeInfoUuid(getAreaCodeUuid(a));
              setMobileErr(false);
              if (m !== mobile) setMobile(m);
            }}
          />
        </ItemWrapper>
        {mobileErr && (
          <div className={css.errContainer}>
            {getI18n(
              'giftCard.giftCardDetail.issueinfo_editor_return_Mobile_err',
            )}
          </div>
        )}
        {validateErr && (
          <div className={css.errContainer}>
            {getI18n(
              'giftCard.giftCardDetail.issueinfo_editor_return_contact_err',
            )}
          </div>
        )}
      </div>
      <ModalFooter
        okText={getI18n(
          'giftCard.giftCardDetail.issueinfo_editor_return_modalfooter_okText',
        )}
        cancelText={getI18n(
          'giftCard.giftCardDetail.issueinfo_editor_return_modalfooter_cancelText',
        )}
        onOk={handleOnSubmit}
        onCancel={onCancel}
      />
    </React.Fragment>
  );
};
export default Editor;
